import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./components/App"
import { UserProvider } from "./contexts/UserContext"
import { enhanceMath } from "./lib/enhanceMath"
import { installQuestionImages } from "./lib/questionImages"
import type { User } from "./types"

function parseUserData(data: string | undefined): User | null {
  if (!data) return null
  try {
    return JSON.parse(data)
  } catch {
    return null
  }
}

document.addEventListener("DOMContentLoaded", () => {
  installQuestionImages()
  enhanceMath()
  const container = document.getElementById("app-root")

  if (container) {
    const userData = parseUserData(container.dataset.user)
    const firstTime = container.dataset.firstTime === "true"
    const root = createRoot(container)
    root.render(
      <BrowserRouter>
        <UserProvider initialUser={userData}>
          <App firstTime={firstTime} />
        </UserProvider>
      </BrowserRouter>
    )
  }
})
